import { render, staticRenderFns } from "./editarEventoDialog.vue?vue&type=template&id=1d8bb79c"
import script from "./editarEventoDialog.vue?vue&type=script&lang=js"
export * from "./editarEventoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports